<div class="notification-container" [@slideNotification]="showNotification">
	<div class="notification-item" role="alert">
		<button class="modal-close" (click)="stopNotification()">
			<office-icon name="close"></office-icon>
		</button>

		<div class="user-area" *ngIf="event">
			<div class="user-info" *ngIf="eventStatus === 'waiting'">
				<img
					alt="waiting"
					class="avatar"
					src="/assets/icons/notifications/instant-session/await.svg"
				/>

				<div class="online-session-data">
					<p>
						<span class="online-name">{{ event.userName }} </span>
						{{ 'SCHEDULE.NOTIFICATIONS.SCHEDULING' | translate }}
					</p>
					<p>
						{{ 'SCHEDULE.NOTIFICATIONS.AWAITPAYMENT' | translate }}
					</p>
				</div>
			</div>

			<div class="user-info" *ngIf="eventStatus === 'paid'">
				<img
					alt="success"
					class="imgAvatar"
					src="/assets/icons/notifications/instant-session/success.svg"
				/>
				<div class="online-session-data">
					<p>
						<span class="online-name">{{ event.userName }} </span>
						{{ 'SCHEDULE.NOTIFICATIONS.SCHEDULED' | translate }}
					</p>
				</div>
			</div>

			<div class="user-info" *ngIf="eventStatus === 'cancelled'">
				<img
					alt="cancelled"
					class="imgAvatar"
					src="/assets/icons/notifications/instant-session/cancelled.svg"
				/>

				<div class="online-session-data">
					<p>
						<span class="online-name">{{ event.userName }} </span>

						{{ 'SCHEDULE.NOTIFICATIONS.SESSIONUNPAID' | translate }}
					</p>
					<p>
						{{ 'SCHEDULE.NOTIFICATIONS.CANCELED' | translate }}
					</p>
				</div>
			</div>
		</div>

		<div class="action-buttons">
			<button
				zk-button
				(click)="openConference()"
				[disabled]="this.eventStatus != 'paid'"
				type="button"
			>
				<span>{{ 'SCHEDULE.NOTIFICATIONS.GOTOCONFERENCE' | translate }}</span>
			</button>

			<button
				zkAnchor
				class="show-session"
				[disabled]="eventStatus === 'cancelled'"
				(click)="showEventDetails()"
			>
				{{ 'SCHEDULE.NOTIFICATIONS.VIEWEVENT' | translate }}
			</button>

			<div class="toggle-button">
				<freud-input-switch
					class="toggle-status__switch zk-mt-1"
					[(ngModel)]="preferences.soundAlert"
					(valueChange)="toggleAudioAlert($event)"
				></freud-input-switch>

				<span>{{
					'SCHEDULE.NOTIFICATIONS.SOUNDNOTIFICATION' | translate
				}}</span>
			</div>
		</div>
	</div>
</div>
